import AttributionHelpers from './attribution';
import { MARKETO_INSTANCE_ID } from '../constants';
import Introspect from './introspection';

const MarketoHelpers = {
  buildMarketoPayload(formData, props) {
    const settings = props.settings || {};
    const sendObject = { ...formData, formId: props.formId || 0 };

    const pageUrl = ((window && window.location) ? window.location.href : 'http://localhost');
    const brandData = Introspect.brandFromUrl(pageUrl);
    // eslint-disable-next-line no-underscore-dangle
    const cookieData = AttributionHelpers._parseCookies();

    // Set the Special Hidden Attributes
    sendObject.munchkinId = MARKETO_INSTANCE_ID;
    sendObject.mops_xid = window.localStorage.getItem('mops_xid');
    sendObject.utm_initial_landing_page__c = window.location.href;
    sendObject.utm_last_landing_page__c = window.location.href;
    sendObject.utm_initial_point_of_origin__c = document.referrer;

    // Assign values from the Query String
    const qs = AttributionHelpers.queryStringToObject();

    sendObject.utmcampaign = (Object.prototype.hasOwnProperty.call(qs, 'utm_campaign') ? qs.utm_campaign : '');
    sendObject.utmsource = (Object.prototype.hasOwnProperty.call(qs, 'utm_source') ? qs.utm_source : '');
    sendObject.utmmedium = (Object.prototype.hasOwnProperty.call(qs, 'utm_medium') ? qs.utm_medium : '');
    sendObject.utmcontent = (Object.prototype.hasOwnProperty.call(qs, 'utm_content') ? qs.utm_content : '');
    sendObject.utmterm = (Object.prototype.hasOwnProperty.call(qs, 'utm_term') ? qs.utm_term : '');
    sendObject.partner = (Object.prototype.hasOwnProperty.call(qs, 'partner') ? qs.partner : brandData.partner);
    sendObject.Promotion__c = (Object.prototype.hasOwnProperty.call(qs, 'promo') ? qs.promo : '');
    sendObject.Sales_Token__c = (Object.prototype.hasOwnProperty.call(qs, 'rep') ? qs.rep : '');
    sendObject.Facebook_Click_ID__c = (Object.prototype.hasOwnProperty.call(qs, 'fbclid') ? qs.fbclid : '');
    sendObject.GCLID__c = (Object.prototype.hasOwnProperty.call(qs, 'gclid') ? qs.gclid : '');
    // eslint-disable-next-line no-underscore-dangle
    sendObject.mkt_tok = (Object.prototype.hasOwnProperty.call(qs, 'mkt_tok') ? qs.mkt_tok : cookieData._mkto_trk);

    sendObject.Company = formData.Company;
    sendObject.FirstName = formData.FirstName;
    sendObject.LastName = formData.LastName;
    sendObject.Phone = formData.Phone;
    sendObject.Email = formData.Email;
    sendObject.demoRequestDate = formData.demoRequestDate;
    sendObject.demoRequestTime = formData.demoRequestTime;
    sendObject.commentCapture = formData.commentCapture;

    // Override everything with values from the settings object if they are set.
    if (settings && Object.prototype.hasOwnProperty.call(settings, 'sales_rep') && settings.sales_rep !== '') {
      sendObject.Sales_Token__c = settings.sales_rep;
    }

    if (settings && Object.prototype.hasOwnProperty.call(settings, 'promo') && settings.promo !== '') {
      sendObject.Promotion__c = settings.promo;
    }

    if (settings && Object.prototype.hasOwnProperty.call(settings, 'partner') && settings.partner !== '') {
      sendObject.Partner_Token__c = settings.partner;
    }

    if (settings && Object.prototype.hasOwnProperty.call(settings, 'utm_source') && settings.utm_source !== '') {
      sendObject.utmsource = settings.utm_source;
    }

    if (settings && Object.prototype.hasOwnProperty.call(settings, 'utm_medium') && settings.utmmedium !== '') {
      sendObject.utmmedium = settings.utm_medium;
    }

    if (settings && Object.prototype.hasOwnProperty.call(settings, 'utm_campaign') && settings.utm_campaign !== '') {
      sendObject.utmcampaign = settings.utm_campaign;
    }

    if (settings && Object.prototype.hasOwnProperty.call(settings, 'utm_content') && settings.utm_content !== '') {
      sendObject.utmcontent = settings.utm_content;
    }

    if (settings && Object.prototype.hasOwnProperty.call(settings, 'utm_term') && settings.utm_term !== '') {
      sendObject.utmterm = settings.utm_term;
    }

    return sendObject;
  },
  async submitToMarketo(formData, settings) {
    const formSettings = settings || {};
    const sendObject = MarketoHelpers.buildMarketoPayload(formData, formSettings);
    try {
      return await AttributionHelpers.sendFormPayload(sendObject);
    } catch (err) {
      return err;
    }
  },
};

export default MarketoHelpers;
